import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UtilService {

  DATA_URL = '/assets/data/';

  constructor() {
  }

  getUrl(file: string): string {
    return this.DATA_URL + file + '?nonce=' + this.getNonce();
  }

  getNonce(): string {
    return Math.random().toString(36).substring(7);
  }
}
